import { Spinner } from "@components/ui-kit";
import {
  QueryContactsOrderByColumn,
  SortOrder,
  useClientFilterOptionsQuery,
  useGetClientsQuery,
} from "@src/__generated__/urql-graphql";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks";
import { getParamFromQuery } from "@src/utils/url";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { Fragment, useEffect } from "react";
import { CardListClients } from "./CardListClients";
import { ClientListItemModel } from "./models";
import { useStore } from "./store";

export const PageClients = withCan(
  { do: "brand_read" },
  observer(function PageClients() {
    const store = useStore();
    const { query } = useRouter();

    useEffect(() => {
      store.searchTerm = getParamFromQuery("search", query) ?? "";
      store.where.fromURLSearchParam(query);
      store.orderBy.fromURLSearchParam(query);
    }, []);

    const [{ data, fetching }, refetch] = useGetClientsQuery({
      pause: true,
      variables: {
        ...store.queryParams,
        onlyActive: true,
      },
    });

    const [{ data: filterOptions }] = useClientFilterOptionsQuery({
      pause: store.filtersSet,
      variables: {
        orderBy: [
          {
            order: SortOrder.Asc,
            column: QueryContactsOrderByColumn.FirstName,
          },
        ],
      },
    });

    useEffect(() => {
      store.refetch = refetch;
      refetch();
    }, [refetch]);

    useEffect(() => {
      store.setFilterOptions(filterOptions);
    }, [filterOptions]);

    useEffect(() => {
      if (!data?.clients) return;
      store.pagination.setFromPaginatorInfo(data.clients.paginatorInfo);

      const responseClients = data.clients.data;
      const responseClientsCount = responseClients?.length ?? 0;

      for (let i = 0; i < responseClientsCount; i++) {
        if (!responseClients?.[i]) continue;

        store.clients.push(new ClientListItemModel(responseClients[i]));
      }

      return () => {
        store.clients = [];
      };
    }, [data]);

    useUpdateURI(store.searchParams);

    return (
      <Fragment>
        {fetching && <Spinner absolute />}
        <CardListClients />
      </Fragment>
    );
  }),
);
